/* BFCM 2026 Phase 3 — sitewide sale touches. Reads RBSale; computes no
   thresholds, gaps or subtotals of its own (BFCM rule 1). */
(function () {
  'use strict';
  if (window.__rbBfTouchesBound) return;
  window.__rbBfTouchesBound = true;
  var S = window.RBSale;
  if (!S) return;

  function t1() {
    var t = (S.data && S.data.tiers) || {};
    return Number(t.t1 && t.t1.threshold) || 0;
  }

  /* ---- H: the card gift line ------------------------------------------------
     "✦ Unlocks a mystery gift" when the card's sale price alone reaches tier
     one in the shopper's currency. Cards arrive late (the filter re-render,
     load-more, recommendations), so new ones are picked up as they land. */
  function cards(root) {
    var th = t1();
    if (!th) return;
    [].forEach.call((root || document).querySelectorAll('[data-bf-card-sale]:not([data-bf-done])'), function (el) {
      el.setAttribute('data-bf-done', '');
      var line = el.querySelector('[data-bf-card-gift]');
      if (line) line.hidden = !(Number(el.getAttribute('data-bf-price')) >= th);
    });
  }
  cards();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; cards(); });
  }).observe(document.body, { childList: true, subtree: true });

  function money(cents) {
    var str = S.money ? S.money(cents) : '';
    return typeof str === 'string' ? str.replace(/([.,])00(?!\d)/, '') : str;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---- K: Free Shipping Friday band -----------------------------------------
     Copy from settings, numbers from the engine; the clock on rb:sale:tick
     (BFCM rule 10). */
  [].forEach.call(document.querySelectorAll('[data-bf-fsf]'), function (root) {
    var msg = root.querySelector('[data-bf-fsf-msg]');
    var gifts = root.querySelector('[data-bf-fsf-gifts]');
    var clock = root.querySelector('[data-bf-fsf-clock]');
    var min = Number(S.data && S.data.fsf && S.data.fsf.min) || 0;
    var override = root.getAttribute('data-bf-msg-override');
    msg.textContent = override || (min > 0
      ? root.getAttribute('data-bf-msg-min').replace('{min}', money(min))
      : root.getAttribute('data-bf-msg-nomin'));
    gifts.textContent = root.getAttribute('data-bf-chip-gifts').replace('{tier1}', money(t1()));
    var prefix = root.getAttribute('data-bf-clock-prefix');
    function tick() {
      if (!S.countdown) return;
      var c = S.countdown('fsfEnd');
      /* At zero the clock hides; the band stays until Free Shipping Friday
         is unticked (state is set by hand, never by the clock). */
      clock.style.display = c.done ? 'none' : '';
      clock.textContent = prefix + ' ' + pad(c.d * 24 + c.h) + 'h ' + pad(c.m) + 'm ' + pad(c.s) + 's';
    }
    tick();
    document.addEventListener('rb:sale:tick', tick);
  });

  /* ---- collection-2026: put F and K where the design has them --------------
     That template's title, tabs and grid are ONE section, so a separate
     section can only sit above or below all of it. F moves to just after the
     title (before the tabs), K to just above the grid. The template has no
     filter re-render and no pagination, so one move on load holds. If this
     does not run, both simply stay above the section: visible, not lost. */
  (function placeInC26() {
    var c26 = document.querySelector('.c26 .c26__inner');
    var sum = document.querySelector('[data-bf-summary]');
    if (!c26) {
      /* Dawn's collection template. F renders in the footer group
         (sections/rb-bf-collection-touches.liquid), so it is moved to just
         after the collection banner, or above the product grid if the
         template has no banner. */
      if (!sum) return;
      var banner = document.querySelector('.shopify-section[id$="__banner"]');
      if (!banner) { var hero = document.querySelector('.collection-hero'); banner = hero && hero.closest('.shopify-section'); }
      if (banner) {
        /* A collection strip set to "Under the collection image" sits directly
           after the banner (sections/rb-collection-strip.liquid) — F goes after
           it, so the strip stays directly under the image (25 Oct 2026). */
        var next = banner.nextElementSibling;
        var ref = (next && next.querySelector && next.querySelector('[data-rb-strip-under]')) ? next.nextSibling : banner.nextSibling;
        banner.parentNode.insertBefore(sum, ref);
        return;
      }
      var pg = document.getElementById('product-grid'); var pgs = pg && pg.closest('.shopify-section');
      if (pgs) pgs.parentNode.insertBefore(sum, pgs);
      return;
    }
    var head = c26.querySelector('.c26__head'), grid = c26.querySelector('.c26__grid');
    if (sum && head) head.parentNode.insertBefore(sum, head.nextSibling);
    var fsf = document.querySelector('[data-bf-fsf]');
    if (fsf && grid) {
      grid.parentNode.insertBefore(fsf, grid);
      /* The tabs have no bottom margin, so K sat flush under them while the
         grid's own top margin (the section's grid_space_top) spaced it from
         the products. Mirror that margin above K so the two gaps match and
         follow the setting. */
      fsf.style.marginTop = getComputedStyle(grid).marginTop;
    }
  })();

  /* ---- F: collection sale summary --------------------------------------------- */
  [].forEach.call(document.querySelectorAll('[data-bf-summary]'), function (root) {
    var t = (S.data && S.data.tiers) || {};
    var map = {
      total: money(t.totalValue || 0), tier1: money(t1()),
      tier2: money(Number(t.t2 && t.t2.threshold) || 0), t1Value: money(t.t1 ? t.t1.value : 0)
    };
    function fill(tpl, m) { return String(tpl || '').replace(/\{(\w+)\}/g, function (x, k) { return m.hasOwnProperty(k) ? m[k] : ''; }); }
    /* Each figure is a text template from the settings, so plain text in
       the setting overrides the engine's figure outright. */
    root.querySelector('[data-bf-sum-total]').textContent = fill(root.getAttribute('data-bf-fig2-value'), map);
    root.querySelector('[data-bf-sum-total-l]').textContent = fill(root.getAttribute('data-bf-fig2-label'), map);
    var left = root.querySelector('[data-bf-sum-left]');
    var leftTpl = root.getAttribute('data-bf-fig3-value');
    function tick() {
      if (!S.countdown) return;
      var c = S.countdown('saleEnd');
      /* The figure is only a countdown: at zero it hides (inline style, since
         body.rb-sale-final-weekend displays it). */
      left.parentNode.style.display = c.done ? 'none' : '';
      left.textContent = fill(leftTpl, { hh: pad(c.d * 24 + c.h), mm: pad(c.m) });
    }
    tick();
    document.addEventListener('rb:sale:tick', tick);
  });

  /* ---- C: mystery gift strip ------------------------------------------------- */
  [].forEach.call(document.querySelectorAll('[data-bf-strip]'), function (root) {
    var t = (S.data && S.data.tiers) || {};
    var stock = (S.data && S.data.stock) || {};
    var map = {
      tier1: money(t1()),
      tier2: money(Number(t.t2 && t.t2.threshold) || 0),
      t1Value: money(t.t1 ? t.t1.value : 0),
      t2Value: money(t.t2 ? t.t2.value : 0),
      total: money(t.totalValue || 0)
    };
    function fillIn(tpl) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : ''; }); }
    /* AN INVERTED PAIR IS NOT A SECOND TIER (as 3.3 and 3.7 treat it): if
       tier two's threshold is not above tier one's, the tier-two card would
       read "Spend {a smaller number}+ … both gifts". It is hidden, and the
       tier-one card takes the row. Live in NZ on 2026-09-28 (t2 $20, t1 $140). */
    var th1 = t1(), th2 = Number(t.t2 && t.t2.threshold) || 0;
    if (!(th2 > th1 && th1 > 0)) {
      var c2 = root.querySelector('[data-bf-strip-card="t2"]');
      if (c2) c2.hidden = true;
      root.classList.add('rb-bf-strip--one');
    }
    [].forEach.call(root.querySelectorAll('[data-bf-strip-card]:not([data-bf-strip-image])'), function (card) {
      card.querySelector('[data-bf-strip-spend]').textContent = fillIn(card.getAttribute('data-bf-spend'));
      card.querySelector('[data-bf-strip-line]').textContent = fillIn(card.getAttribute('data-bf-line'));
      var st = stock[card.getAttribute('data-bf-strip-card')] || {};
      var pct = (st.pct === null || st.pct === undefined || st.pct === '') ? null : Number(st.pct);
      var box = card.querySelector('[data-bf-strip-stock]');
      if (pct === null || isNaN(pct)) { box.hidden = true; return; }   /* hide, never fake (rule 9) */
      pct = Math.max(0, Math.min(100, pct));
      box.hidden = false;
      card.querySelector('[data-bf-strip-fill]').style.width = pct + '%';
      box.querySelector('[role="meter"]').setAttribute('aria-valuenow', String(pct));
      /* A status override (setting) replaces the engine's text; the bar still
         follows the engine, so it never shows stock that is not there. */
      card.querySelector('[data-bf-strip-status]').textContent = fillIn(card.getAttribute('data-bf-status')) || st.status || '';
    });
  });

  /* ---- I: in-grid gift tile ------------------------------------------------------
     Cloned from the section's <template> into Dawn's #product-grid. See
     sections/rb-bf-collection-touches.liquid for the settings;
     the guards are explained in docs/bfcm/BFCM_Phase_3_PR.md. */
  (function gridTile() {
    var tpl = document.querySelector('template[data-bf-tile-tpl]');
    if (!tpl) return;
    var page = Number(new URLSearchParams(location.search).get('page') || 1);
    if (page > 1) return;
    var pos = Math.max(1, Number(tpl.getAttribute('data-bf-position')) || 5);
    var t = (S.data && S.data.tiers) || {};
    var th1 = t1(), th2 = Number(t.t2 && t.t2.threshold) || 0;
    var map = { tier1: money(th1), tier2: money(th2), t1Value: money(t.t1 ? t.t1.value : 0), total: money(t.totalValue || 0) };
    function fillIn(str) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : ''; }); }
    var body = fillIn((th2 > th1 && th1 > 0) ? tpl.getAttribute('data-bf-body') : tpl.getAttribute('data-bf-body-one'));
    var statusOverride = fillIn(tpl.getAttribute('data-bf-status'));
    /* The lower of the two tiers' stock; null for both hides the bar. */
    var stock = (S.data && S.data.stock) || {}, pick = null;
    ['t1', 't2'].forEach(function (k) {
      var st = stock[k] || {}; var pct = (st.pct === null || st.pct === undefined || st.pct === '') ? null : Number(st.pct);
      if (pct !== null && !isNaN(pct) && (pick === null || pct < pick.pct)) pick = { pct: Math.max(0, Math.min(100, pct)), status: st.status || '' };
    });

    function place() {
      /* Dawn's ul#product-grid, or collection-2026's ul.c26__grid. */
      var grid = document.getElementById('product-grid');
      if (!grid || grid.tagName !== 'UL') grid = document.querySelector('ul.c26__grid');
      if (!grid || grid.querySelector('[data-bf-tile]')) return;
      var li = tpl.content.firstElementChild.cloneNode(true);
      /* Image mode has none of these; the tile is the image. */
      var bodyEl = li.querySelector('[data-bf-tile-body]');
      if (bodyEl) bodyEl.textContent = body;
      var box = li.querySelector('[data-bf-tile-stock]');
      if (pick && box) {
        box.hidden = false;
        li.querySelector('[data-bf-tile-fill]').style.width = pick.pct + '%';
        li.querySelector('[data-bf-tile-status]').textContent = statusOverride || pick.status;
        box.querySelector('[role="meter"]').setAttribute('aria-valuenow', String(pick.pct));
      }
      var items = grid.children;
      grid.insertBefore(li, items[pos - 1] || null);
    }
    place();

    /* The How it works pop-up: a native modal <dialog>. Delegated, because
       the tile's opener is a CLONE that facets.js may replace at any time. */
    var dlg = document.querySelector('[data-bf-tile-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      document.body.appendChild(dlg);   /* out of the footer's stacking and overflow */
      var rte = dlg.querySelector('[data-bf-modal-rte]');
      if (rte) rte.innerHTML = rte.innerHTML.replace(/\{(\w+)\}/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : m; });
      var opener = null;
      var focusables = function () {
        return [].filter.call(dlg.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (e) { return !e.disabled && e.offsetParent !== null; });
      };
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-bf-tile-modal]');
        if (!btn) return;
        e.preventDefault();
        opener = btn;
        document.documentElement.classList.add('rb-bf-modal-open');
        dlg.showModal();
        dlg.querySelector('[data-bf-modal-close]').focus();
      });
      dlg.querySelector('[data-bf-modal-close]').addEventListener('click', function () { dlg.close(); });
      /* The dialog box is the backdrop's only hit target outside .inner. */
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      /* Tab stays inside (showModal alone lets it reach the browser chrome). */
      dlg.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* Esc fires 'cancel' then 'close'; every route ends here. */
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('rb-bf-modal-open');
        if (opener && document.contains(opener)) opener.focus();
        opener = null;
      });
    }

    /* facets.js swaps the grid out; put the tile into the new one. */
    var wait = false;
    new MutationObserver(function () {
      if (wait) return; wait = true;
      requestAnimationFrame(function () { wait = false; place(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---- E: floating gift progress pill ---------------------------------------- */
  (function pill() {
    var root = document.querySelector('[data-bf-pill]');
    if (!root) return;
    var KEY = 'rb_bf_pill_dismissed';
    var body = document.body.classList;
    function dismissed() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    var line = root.querySelector('[data-bf-pill-line]');
    var sub = root.querySelector('[data-bf-pill-sub]');
    function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : ''; }); }

    function paint() {
      /* Live sale, or Gift promo (tracker + pill only, 1 Oct 2026). */
      var st = S.state ? S.state() : {};
      var live = st.phase === 'live' || st.gwp === true;
      var p = S.progress(0);
      var excluded = body.contains('template-product') || body.contains('template_page_black-friday');
      /* No tiers for this currency: no pill (1 Oct 2026). */
      var tiersOn = !(S.data && S.data.tiers && S.data.tiers.active === false);
      var show = live && tiersOn && !excluded && !dismissed() && p.subtotal > 0;
      root.hidden = !show;
      if (!show) return;
      var t = (S.data && S.data.tiers) || {};
      var t1 = Number(t.t1 && t.t1.threshold) || 0, t2 = Number(t.t2 && t.t2.threshold) || 0;
      var twoValid = t2 > t1 && t1 > 0;
      var pct = twoValid ? p.pctToT2 : (t1 > 0 ? Math.min(1, p.subtotal / t1) : 0);
      root.style.setProperty('--bfpl-deg', Math.round(pct * 360) + 'deg');
      root.style.setProperty('--bfpl-t1deg', twoValid ? Math.round((t1 / t2) * 360) + 'deg' : '360deg');
      var both = twoValid ? p.t2Reached : p.t1Reached;
      /* SINGLE TIER (1 Oct 2026): no tier two for this currency, so the ring
         runs to tier one (above) and, once reached, the line is its own
         setting, never "both gifts". */
      var key = !twoValid ? (p.t1Reached ? 'single' : 'below') : (both ? 't2' : (p.t1Reached ? 't1' : 'below'));
      if (key === 'single' && !root.hasAttribute('data-bf-l-single')) key = 't2';
      var map = { gap: money(p.gap), subtotal: money((S.cart && S.cart.total_price) || 0), total: money(t.totalValue || 0) };
      line.textContent = fill(root.getAttribute('data-bf-l-' + key), map);
      sub.textContent = fill(root.getAttribute(both && twoValid ? 'data-bf-s-gifts' : 'data-bf-s-bag'), map);
    }

    root.querySelector('[data-bf-pill-open]').addEventListener('click', function () {
      if (typeof window.fetchCart === 'function') window.fetchCart();
      else if (typeof window.toggleCart === 'function') window.toggleCart();
    });
    root.querySelector('[data-bf-pill-dismiss]').addEventListener('click', function () {
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      root.hidden = true;
    });
    paint();
    document.addEventListener('rb:sale:cart', paint);
    document.addEventListener('rb:sale:phase', paint);
  })();
})();
